import React from 'react'

function blogArchive() {
  return (
    <>
    <section className="inner-banner-wrap">
      <div
        className="inner-baner-container"
        style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
      >
        <div className="container">
          <div className="inner-banner-content">
            <h1 className="inner-title">Blog</h1>
          </div>
        </div>
      </div>
    </section>
    {/* Inner Banner html end*/}
    {/* Blog html start */}
    <div className="blog-page-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 primary right-sidebar">
            <div className="blog-page-inner">
              <div className="row grid">
                <div className="col-md-6 grid-item">
                  <article className="post">
                    <figure className="feature-image">
                      <a href="#">
                        <img src="assets/images/img21.jpg" alt="" />
                      </a>
                    </figure>
                    <div className="entry-content">
                      <h4>
                        <a href="#">Corporating Others Is Must In Business</a>
                      </h4>
                      <div className="entry-meta">
                        <span className="byline">
                          <a href="#">Demoteam</a>
                        </span>
                        <span className="posted-on">
                          <a href="#">August 17, 2021</a>
                        </span>
                        <span className="comments-link">
                          <a href="#">No Comments</a>
                        </span>
                      </div>
                      <p>
                        Cupiditate? Quae modi odio occaecat qui fusce veritatis.
                        Hymenaeos dapibus tempus expedita eu venenatis quaerat,
                      </p>
                      <a href="#" className="button-text">
                        CONTINUE READING...
                      </a>
                    </div>
                  </article>
                </div>
                <div className="col-md-6 grid-item">
                  <article className="post">
                    <figure className="feature-image">
                      <a href="#">
                        <img src="assets/images/img22.jpg" alt="" />
                      </a>
                    </figure>
                    <div className="entry-content">
                      <h4>
                        <a href="#">
                          Creating Daily Activities For Flowless Business
                        </a>
                      </h4>
                      <div className="entry-meta">
                        <span className="byline">
                          <a href="#">Demoteam</a>
                        </span>
                        <span className="posted-on">
                          <a href="#">August 17, 2021</a>
                        </span>
                        <span className="comments-link">
                          <a href="#">No Comments</a>
                        </span>
                      </div>
                      <p>
                        Cupiditate? Quae modi odio occaecat qui fusce veritatis.
                        Hymenaeos dapibus tempus expedita eu venenatis quaerat,
                      </p>
                      <a href="#" className="button-text">
                        CONTINUE READING...
                      </a>
                    </div>
                  </article>
                </div>
                <div className="col-md-6 grid-item">
                  <article className="post">
                    <figure className="feature-image">
                      <a href="#">
                        <img src="assets/images/img23.jpg" alt="" />
                      </a>
                    </figure>
                    <div className="entry-content">
                      <h4>
                        <a href="#">A Step To Social Media Marketing Strategy</a>
                      </h4>
                      <div className="entry-meta">
                        <span className="byline">
                          <a href="#">Demoteam</a>
                        </span>
                        <span className="posted-on">
                          <a href="#">August 17, 2021</a>
                        </span>
                        <span className="comments-link">
                          <a href="#">No Comments</a>
                        </span>
                      </div>
                      <p>
                        Cupiditate? Quae modi odio occaecat qui fusce veritatis.
                        Hymenaeos dapibus tempus expedita eu venenatis quaerat,
                      </p>
                      <a href="#" className="button-text">
                        CONTINUE READING...
                      </a>
                    </div>
                  </article>
                </div>
                <div className="col-md-6 grid-item">
                  <article className="post">
                    <figure className="feature-image">
                      <a href="#">
                        <img src="assets/images/img14.jpg" alt="" />
                      </a>
                    </figure>
                    <div className="entry-content">
                      <h4>
                        <a href="#">Main Reason To Fast Business Builder</a>
                      </h4>
                      <div className="entry-meta">
                        <span className="byline">
                          <a href="#">Demoteam</a>
                        </span>
                        <span className="posted-on">
                          <a href="#">August 17, 2021</a>
                        </span>
                        <span className="comments-link">
                          <a href="#">No Comments</a>
                        </span>
                      </div>
                      <p>
                        Cupiditate? Quae modi odio occaecat qui fusce veritatis.
                        Hymenaeos dapibus tempus expedita eu venenatis quaerat,
                      </p>
                      <a href="#" className="button-text">
                        CONTINUE READING...
                      </a>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 secondary">
            <div className="sidebar">
              <aside className="widget widget_latest_post widget-post-thumb">
                <h3 className="widget-title">Recent Post</h3>
                <ul>
                  <li>
                    <figure className="post-thumb">
                      <a href="/">
                        <img src="assets/images/img14.jpg" alt="" />
                      </a>
                    </figure>
                    <div className="post-content">
                      <h5>
                        <a href="/">
                          Main Reason To Fast Business Builder
                        </a>
                      </h5>
                      <div className="entry-meta">
                        <span className="posted-on">
                          <a href="/">Aug 17, 2022</a>
                        </span>
                        <span className="comments-link">
                          <a href="/">No Comments</a>
                        </span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <figure className="post-thumb">
                      <a href="/">
                        <img src="assets/images/img21.jpg" alt="" />
                      </a>
                    </figure>
                    <div className="post-content">
                      <h5>
                        <a href="/">
                          A Step To Social Media Marketing Strategy
                        </a>
                      </h5>
                      <div className="entry-meta">
                        <span className="posted-on">
                          <a href="/">Aug 17, 2022</a>
                        </span>
                        <span className="comments-link">
                          <a href="/">No Comments</a>
                        </span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <figure className="post-thumb">
                      <a href="/">
                        <img src="assets/images/img22.jpg" alt="" />
                      </a>
                    </figure>
                    <div className="post-content">
                      <h5>
                        <a href="/">
                          Creating Daily Activities For Flowless Business
                        </a>
                      </h5>
                      <div className="entry-meta">
                        <span className="posted-on">
                          <a href="/">Aug 17, 2022</a>
                        </span>
                        <span className="comments-link">
                          <a href="/">No Comments</a>
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </aside>
              <aside className="widget widget_social">
                <h3 className="widget-title">Social share</h3>
                <div className="social-icon-wrap">
                  <div className="social-icon social-facebook">
                    <a href="https://www.facebook.com/">
                      <i className="fab fa-facebook-f" />
                      <span>Facebook</span>
                    </a>
                  </div>
                  <div className="social-icon social-pinterest">
                    <a href="https://www.pinterest.com/">
                      <i className="fab fa-pinterest" />
                      <span>Pinterest</span>
                    </a>
                  </div>
                  <div className="social-icon social-whatsapp">
                    <a href="https://www.whatsapp.com/">
                      <i className="fab fa-whatsapp" />
                      <span>WhatsApp</span>
                    </a>
                  </div>
                  <div className="social-icon social-linkedin">
                    <a href="https://www.linkedin.com/">
                      <i className="fab fa-linkedin" />
                      <span>Linkedin</span>
                    </a>
                  </div>
                  <div className="social-icon social-twitter">
                    <a href="https://www.twitter.com/">
                      <i className="fab fa-twitter" />
                      <span>Twitter</span>
                    </a>
                  </div>
                  <div className="social-icon social-google">
                    <a href="https://www.google.com/">
                      <i className="fab fa-google-plus-g" />
                      <span>Google</span>
                    </a>
                  </div>
                </div>
              </aside>
              <aside className="widget widget_gallery">
                <h3 className="widget-title">Our Gallery</h3>
                <div className="gallery gallery-colum-3">
                  <figure className="gallery-item">
                    <a href="/">
                      <img src="assets/images/img2.jpg" alt="" />
                    </a>
                  </figure>
                  <figure className="gallery-item">
                    <a href="/">
                      <img src="assets/images/img3.jpg" alt="" />
                    </a>
                  </figure>
                  <figure className="gallery-item">
                    <a href="/">
                      <img src="assets/images/img4.jpg" alt="" />
                    </a>
                  </figure>
                  <figure className="gallery-item">
                    <a href="/">
                      <img src="assets/images/img5.jpg" alt="" />
                    </a>
                  </figure>
                  <figure className="gallery-item">
                    <a href="/">
                      <img src="assets/images/img6.jpg" alt="" />
                    </a>
                  </figure>
                  <figure className="gallery-item">
                    <a href="/">
                      <img src="assets/images/img7.jpg" alt="" />
                    </a>
                  </figure>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  
  )
}

export default blogArchive
